// @flow

import { createSelector } from 'reselect';

import { findByType } from 'shared/utils/json-api/helpers';
import getFirstParagraph from 'shared/utils/getFirstParagraph';

import type { NewsSelectorResult, SelectorParamsType } from './types';

export const newsSelector = (
  newsData: ?JsonApiArrayDataType,
  { locale, isFormatImg }: SelectorParamsType
): NewsSelectorResult => {
  if (!newsData || !newsData.data) return { list: [], meta: {} };

  const { data, included, meta } = newsData;

  return {
    list: data.map(({ id, attributes, relationships }) => {
      const discipline = findByType('discipline', included, relationships.discipline?.data);

      return {
        id,
        img: isFormatImg
          ? {
              original: attributes.img.original,
              small: attributes.img.thumb_small,
              medium: attributes.img.thumb_medium,
              big: attributes.img.thumb_big,
              large: attributes.img.thumb_large
            }
          : attributes.img,
        title: attributes.header,
        description: getFirstParagraph(attributes.content, attributes.format === 'video'),
        publishedAt: attributes.published_at,
        discipline: discipline?.attributes.name || null,
        slug: {
          [locale]: attributes.slug
        },
        isVideo: attributes.format === 'video'
      };
    }),
    meta: {
      currentPage: meta.pagination.current_page,
      totalPages: meta.pagination.total_pages,
      totalCount: meta.pagination.total_count,
      nextPage: meta.pagination.next_page
    }
  };
};

export const memoizedNewsSelector = createSelector(
  // to prevent the recommendation of all in one line
  [(data: JsonApiArrayDataType) => data, (_, params: SelectorParamsType) => params],
  (newsData, params) => newsSelector(newsData, params)
);
